export {default as HelpChatbot} from './chatbot';
export {default as HelpFaq} from './faq';
export {default as HelpFaqDetail} from './faq/[questionId]';
export {default as HelpHome} from './home';
export {default as HelpInquiry} from './inquiry';
export {default as HelpReportContent} from './report';
export {default as HelpReportIllegal} from './reportIllegal';
export {default as HelpObjection} from './objection';
export {default as HelpMyInquiry} from './my-inquiry';
export {default as HelpMyInquiryDetail} from './my-inquiry/[inquiryId]';
export {default as HelpMyInquirySurvey} from './my-inquiry/survey';
export {default as HelpSearch} from './search';
